import { createHelpCenterSlice, helpCenterInitialState } from '@sv-support-sdk/store';

const helpCenter = createHelpCenterSlice({
  name: 'helpCenter',
  initialState: { ...helpCenterInitialState },
  reducers: {},
});

export const helpCenterActions = helpCenter.actions;

export default helpCenter.reducer;
